export const FETCH_AGENT_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_custom_fields`;
export const CREATE_AGENT_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_custom_fields/create`;
export const UPDATE_AGENT_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_custom_fields`;
export const QUERY_AGENT_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_custom_fields/query`;
export const DELETE_AGENT_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_custom_fields`;
